import UnicoUtils from "./script-utils.js";

let mobileSlider;

/**
 * スライダー設定
 */
function initSlider() {
  if (!mobileSlider) {
    mobileSlider = new Swiper('.swiper-container', {
      navigation: {
        nextEl: document.querySelector('.swiper-container').querySelector('.swiper-button-next'),
        prevEl: document.querySelector('.swiper-container').querySelector('.swiper-button-prev'),
      },
      speed: 700,
      simulateTouch: true,
      loop:true,
    });
  };
}

/**
 * スライダーインスタンスを破棄
 */
function destroySlider() {
  if (mobileSlider) {
    mobileSlider.destroy();
    mobileSlider = null;
  }
}

/**
 * ページ読み込み
 */
window.addEventListener('DOMContentLoaded', function() {
  if (UnicoUtils.isSP()) {
    initSlider();
  }
});

/**
 * リサイズ処理
 */
window.addEventListener('resize', function() {
  if (UnicoUtils.isSP()) {
    if (!mobileSlider) {
      initSlider();
    }
  } else {
    if (mobileSlider) {
      destroySlider();
    }
  }
});